export default "__VITE_ASSET__BsPYbVLK__"